import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { isDevMode, LOCALE_ID, inject, provideAppInitializer } from '@angular/core'

export const ICONS_FACTORY = provideAppInitializer(() => {
        const initializerFn = ((iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer, locale: string) => () => {
    const assetsUrl = isDevMode() ? '/assets' : `/${locale}/assets`
    const icons = [
      'app-logo_standalone',
      'icon_email_message',
      'icon_sms_message',
      'about_icon_1',
      'about_icon_2',
      'about_icon_3',
      'about_icon_4',
      'about_icon_5',
      'calc_icon_minus',
      'calc_icon_plus',
      'smart-id',
      'eparaksts',
      '001cent-lv',
      '001cent-ru',
      'trending_flat',
      'chat_bubble_tail',
      'take-loan-chat-icons/car',
      'take-loan-chat-icons/credit',
      'take-loan-chat-icons/garbage-disposal',
      'take-loan-chat-icons/refrigerator',
      'take-loan-chat-icons/repair',
    ]

    const iconUrl = (icon: string) => domSanitizer.bypassSecurityTrustResourceUrl(`${assetsUrl}/${icon}.svg`)

    icons.forEach(icon => {
      iconRegistry.addSvgIcon(icon, iconUrl(icon))
    })

    iconRegistry.addSvgIcon('001cent-en', iconUrl('001cent-lv'))
  })(inject(MatIconRegistry), inject(DomSanitizer), inject(LOCALE_ID))
        return initializerFn()
      })
